import styled from '@emotion/styled'

export const StyleOutletWrapper = styled.div<any>`
  background: ${(props: any) =>
    props?.isWhite ? props.theme.colors['white'] : 'transparent'};
  min-height: 100dvh;
`
